/**
 * @generated SignedSource<<ac6d1edc82ec332515df5884f391ca27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateContactRolesDialog_customerAccount$data = {
  readonly customerName: string;
  readonly id: string;
  readonly " $fragmentType": "UpdateContactRolesDialog_customerAccount";
};
export type UpdateContactRolesDialog_customerAccount$key = {
  readonly " $data"?: UpdateContactRolesDialog_customerAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateContactRolesDialog_customerAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateContactRolesDialog_customerAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerName",
      "storageKey": null
    }
  ],
  "type": "CustomerAccount",
  "abstractKey": null
};

(node as any).hash = "2e4bf73cacbd6270f3b952c0851f541e";

export default node;
